import styled, { css } from 'styled-components'

export const Container = styled.div`
  ${({ isBusinessList }) => isBusinessList && css`
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;
  `}
  ${({ hero, isCheckOut }) => (hero && !isCheckOut) && css`
    position: absolute;
    top: 10%;
  `}
  margin-top: 10px;

  @media (max-width: 576px) {
    padding: 0 15px;
    box-sizing: border-box;
  }
`

export const AddressMenu = styled.div`
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  background-color: #FFF;
  color: #333;
  font-weight: 600;
  border-radius: 50px;
  padding: 10px 20px;
  margin-bottom: 15px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  border: 1px solid #E9ECEF;
  
  @media (min-width: 768px) {
    background-color: ${props => props.theme.colors.backgroundPage};
    color: inherit;
    padding: 13px 19px;
    margin-bottom: 10px;
    box-shadow: none;
    border: none;
  }

  ${({ isCheckOut }) => isCheckOut && css`
    @media (min-width: 768px) {
      background-color: ${props => props.theme.colors.grayDividerColor};
    }
  `}

  span {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
  }
  svg {
    margin-right: 8px;
    min-width: 16px;
    color: #fc0a7e;
    ${props => props.theme?.rtl && css`
      margin-left: 8px;
      margin-right: 0;
    `}
  }
`

export const FeatureItems = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  @media (max-width: 768px) {
    display: none;
  }
`

export const ItemInline = styled.div`
  > * {
    pointer-events: none;
  }
  > span #select-input {
    background-color: ${props => props.theme.colors.grayDividerColor} !important;
    border: none;
    border-radius: 7.6px;
    svg {
      font-size: 14px;
    }
    #list {
      background-color: ${props => props.theme.colors.backgroundPage};
      border: none;
      border-radius: 7.6px;

      left: 0px;
      right: initial;

      ${props => props.theme.rtl && css`
        left: initial;
        right: 0px;
      `}
    }

    > div:first-child {
      font-size: 11px;
    }
  }

  .moment-popover {
    > div:first-child {
      font-size: 11px;
      padding: 4px 7px;
      svg {
        font-size: 14px;
      }
    }
  }
`
